import React, { useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { resetPassword } from "../services/api";

export default function ResetPassword() {
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const navigate = useNavigate();
  const { id: uuid } = useParams();
  const [searchParams] = useSearchParams();

  // URL'den token'ı al
  const [isFromEmailLink, setIsFromEmailLink] = useState(false);
  
  React.useEffect(() => {
    const tokenFromUrl = searchParams.get('token');
    const emailFromUrl = searchParams.get('email');
    if (tokenFromUrl) {
      setToken(tokenFromUrl);
      setIsFromEmailLink(true);
    }
    if (emailFromUrl) {
      setEmail(emailFromUrl);
      setIsFromEmailLink(true);
    }
  }, [searchParams]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    // Validasyonlar
    if (!email || !token || !newPassword || !confirmNewPassword) {
      setError("Lütfen tüm alanları doldurun.");
      setLoading(false);
      return;
    }

    // Email format kontrolü
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Lütfen geçerli bir email adresi girin.");
      setLoading(false);
      return;
    }

    if (newPassword !== confirmNewPassword) {
      setError("Yeni şifreler eşleşmiyor.");
      setLoading(false);
      return;
    }

    if (newPassword.length < 6) {
      setError("Yeni şifre en az 6 karakter olmalıdır.");
      setLoading(false);
      return;
    }

    try {
      const response = await resetPassword(email, token, newPassword, confirmNewPassword);
      setSuccess("Şifreniz başarıyla sıfırlandı!");
      
      // 3 saniye sonra login sayfasına yönlendir
      setTimeout(() => {
        navigate(`/${uuid}/login`);
      }, 3000);
    } catch (error) {
      console.error("Şifre sıfırlama hatası:", error);
      
      if (error.response?.data?.message) {
        setError(error.response.data.message);
      } else if (error.message) {
        setError("Şifre sıfırlanırken bir hata oluştu.");
      } else {
        setError("Token geçersiz veya süresi dolmuş olabilir.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleBackToLogin = () => {
    navigate(`/${uuid}/login`);
  };

  return (
    <div className="h-screen max-h-screen overflow-hidden flex bg-white flex-col items-center justify-start">
      <div
        className="text-center h-[120px] w-full sm:max-w-[390px] flex items-center justify-center"
        style={{
          backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <img
          src="/assets/pngImages/jodiacLogo.png"
          alt="JODIAC Logo"
          className="h-[150px] mb-4 w-auto"
        />
      </div>
      
      <div className="w-full sm:max-w-[390px] -mt-6 z-20 rounded-t-3xl bg-white flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <div className="text-center mb-4 px-5 pt-4">
          <h2 className="text-2xl font-semibold text-black mb-1">
            Şifre Sıfırla
          </h2>
          <p className="text-black text-sm">
            Email adresinizi ve token'ı girerek yeni şifrenizi belirleyin
          </p>
        </div>

        {/* Başarı Mesajı */}
        {success && (
          <div className="mb-4 px-5">
            <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded-full text-sm">
              {success}
            </div>
          </div>
        )}

        {/* Hata Mesajı */}
        {error && (
          <div className="mb-4 px-5">
            <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-full text-sm">
              {error}
            </div>
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="flex-1 flex flex-col px-5">
          <div className="space-y-3">
            {/* Email */}
            <div>
              <input
                type="email"
                placeholder="Email Adresiniz"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className={`w-full px-4 py-2.5 rounded-full border-1 border-[#E9E9E9] shadow-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white/20 ${
                  isFromEmailLink ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'
                }`}
                required
                disabled={loading || isFromEmailLink}
              />
            </div>

            {/* Token */}
            <div>
              <input
                type="text"
                placeholder="Token"
                value={token}
                onChange={(e) => setToken(e.target.value)}
                className={`w-full px-4 py-2.5 rounded-full border-1 border-[#E9E9E9] shadow-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white/20 ${
                  isFromEmailLink ? 'bg-gray-100 cursor-not-allowed' : 'bg-white'
                }`}
                required
                disabled={loading || isFromEmailLink}
              />
            </div>

            {/* Yeni Şifre */}
            <div>
              <input
                type="password"
                placeholder="Yeni Şifre"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                className="w-full bg-white px-4 py-2.5 rounded-full border-1 border-[#E9E9E9] shadow-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white/20"
                required
                disabled={loading}
                minLength={6}
              />
            </div>

            {/* Şifre Tekrar */}
            <div>
              <input
                type="password"
                placeholder="Yeni Şifre Tekrar"
                value={confirmNewPassword}
                onChange={(e) => setConfirmNewPassword(e.target.value)}
                className="w-full bg-white px-4 py-2.5 rounded-full border-1 border-[#E9E9E9] shadow-sm text-gray-700 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-white/20"
                required
                disabled={loading}
                minLength={6}
              />
            </div>
          </div>

          <div className="space-y-3 mt-6">
            {/* Şifre Sıfırla Butonu */}
            <button
              type="submit"
              className="w-full bg-[#3DA7B5] text-white py-2.5 rounded-lg font-normal hover:bg-[#3DA7B5]/80 transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed"
              disabled={loading}
            >
              {loading ? "Şifre Sıfırlanıyor..." : "Şifre Sıfırla"}
            </button>

            {/* Geri Dön Butonu */}
            <button
              type="button"
              onClick={handleBackToLogin}
              className="w-full bg-white text-[#6C6C6E] py-2.5 rounded-lg font-normal transition-colors duration-200 disabled:opacity-50 disabled:cursor-not-allowed border border-[#E9E9E9]"
              disabled={loading}
            >
              Giriş Sayfasına Dön
            </button>
          </div>
        </form>

        {/* Footer */}
        <div className="flex flex-col justify-center items-center px-5 pb-4">
          <div className="w-[179px] border-b border-[#E2E2E2] text-white text-sm">
            &nbsp;
          </div>
          <a
            href="https://store.jodi.ac"
            target="_blank"
            className="w-full mt-4"
          >
            <img
              src="/assets/pngImages/loginBanner.png"
              alt="JODIAC Logo"
              className="w-full h-auto min-h-[128px] max-h-[198px] object-contain"
            />
          </a>
        </div>
      </div>
    </div>
  );
}
